import { useRedirectFunctions } from "@propelauth/react";
import { Button } from "../components/ui/button";

function LoginSignUpPage() {
  const { redirectToSignupPage, redirectToLoginPage } = useRedirectFunctions();
  return (
    <div className={"min-h-screen flex"}>
      <div className="w-1/2 bg-cover bg-center bg-[#0C1527] flex justify-center items-center">
        <img src="/logomark.svg" alt="C-Street Logo" className="h-80 w-80" />
      </div>
      <div className="w-1/2 flex flex-col justify-center items-center bg-gray-100 p-8">
        <div>Welcome to C-Street</div>
        <div>To get started, please log in.</div>

        <Button
          variant="outline"
          size="lg"
          className="w-40 mt-5"
          onClick={() => redirectToLoginPage()}
        >
          Log in
        </Button>
          <Button
          variant="outline"
          size="lg"
          className="w-40 mt-5"
          onClick={() => redirectToSignupPage()}
        >
          Sign up
        </Button>
      </div>
    </div>
  );
}

export default LoginSignUpPage;
